const isRecord = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
const isNonemptyString = (value) => typeof value === 'string' && value.trim().length > 0;
const isImageMap = (value) => isRecord(value) && Object.values(value).every(image => typeof image === 'string');
const isProductMap = (value) => isRecord(value) &&
    Object.values(value).every(product => isRecord(product) &&
        isNonemptyString(product.name) &&
        (product.color === undefined || product.color === null || typeof product.color === 'string') &&
        typeof product.unitPrice === 'number' &&
        Number.isSafeInteger(product.unitPrice) &&
        product.unitPrice >= 0);
export default function parseConfig(json) {
    try {
        const value = JSON.parse(json || '');
        if (!isRecord(value) ||
            !isNonemptyString(value.setting) ||
            !isNonemptyString(value.csrf) ||
            !isNonemptyString(value.baseUrl) ||
            !isNonemptyString(value.locale) ||
            typeof value.isAuthenticated !== 'boolean' ||
            !isNonemptyString(value.successImageUrl) ||
            !isImageMap(value.images) ||
            !isProductMap(value.products)) {
            return null;
        }
        // Validate the locale before the checkout view constructs its currency formatter.
        Intl.NumberFormat.supportedLocalesOf(value.locale);
        return {
            setting: value.setting,
            csrf: value.csrf,
            baseUrl: value.baseUrl,
            locale: value.locale,
            isAuthenticated: value.isAuthenticated,
            successImageUrl: value.successImageUrl,
            images: value.images,
            products: value.products,
        };
    }
    catch {
        return null;
    }
}
